import { ArrowRight, Check } from "lucide-react";
import { BTN_PRIMARY, SECTION_LABEL } from "@/lib/site";
import { track } from "@/lib/track";
import { Reveal } from "@/components/Reveal";
import { Parallax } from "@/components/Parallax";

const BENEFITS = [
    "Project-based collaboration",
    "Clearly defined deliverables and timelines",
    "Flexible support for suitable client projects",
    "Direct communication and agreed handover",
    "Confidentiality and white-label arrangements where agreed",
];

export default function Partnership() {
    return (
        <section
            id="partnership"
            className="relative scroll-mt-20 overflow-hidden bg-[#F7F0EA]"
            data-testid="partnership-section"
        >
            <div
                className="pointer-events-none absolute -left-40 bottom-0 h-[420px] w-[420px] rounded-full bg-[#E8764A]/[0.09] blur-3xl"
                aria-hidden="true"
            />
            <div className="relative mx-auto max-w-7xl px-6 py-24 lg:px-8 lg:py-32">
                <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
                    <Reveal from="right">
                        <p className={SECTION_LABEL}>For Agencies</p>
                        <h2 className="mt-4 font-heading text-3xl font-medium tracking-tight text-[#1C1917] md:text-4xl lg:text-[3.1rem] lg:leading-[1.1]">
                            Need a reliable development partner{" "}
                            <span className="font-serif italic text-[#CF4242]">
                                behind the scenes?
                            </span>
                        </h2>
                        <p className="mt-6 text-base leading-relaxed text-[#57504A] md:text-lg">
                            Deliver more for your clients without immediately expanding your
                            full-time team. We can support defined website, application and
                            automation projects under your agency's brand.
                        </p>
                        <p className="mt-4 text-base leading-relaxed text-[#57504A]">
                            Your behind-the-scenes development partner for websites, web apps
                            and AI-powered solutions.
                        </p>
                        <a
                            href="#contact"
                            data-testid="partnership-discuss-btn"
                            onClick={() => track("cta_click", { cta: "partnership_discuss" })}
                            className={`${BTN_PRIMARY} mt-9`}
                        >
                            Discuss a Partnership <ArrowRight size={16} />
                        </a>
                    </Reveal>

                    <Parallax distance={70}>
                        <Reveal from="left" delay={0.1}>
                            <ul
                                className="spotlight rounded-[1.5rem] border border-[#EDE3DA] bg-gradient-to-br from-white to-[#FDF3EE] p-8 shadow-[0_28px_60px_-28px_rgb(28,25,23,0.35)] sm:p-10"
                                data-testid="partnership-benefits"
                            >
                                {BENEFITS.map((b) => (
                                    <li
                                        key={b}
                                        className="group relative flex items-start gap-3 border-b border-[#F0E4D7] py-4 text-sm font-medium text-[#1C1917] first:pt-0 last:border-0 last:pb-0 md:text-base"
                                    >
                                        <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#FBECE9] ring-1 ring-[#CF4242]/15 transition-colors duration-300 group-hover:bg-[#CF4242]">
                                            <Check
                                                size={14}
                                                className="text-[#CF4242] transition-colors duration-300 group-hover:text-white"
                                                aria-hidden="true"
                                            />
                                        </span>
                                        {b}
                                    </li>
                                ))}
                            </ul>
                        </Reveal>
                    </Parallax>
                </div>
            </div>
        </section>
    );
}
